import React from "react";

import "./composition.scss";

export function DemoTag() {
  return <div className={"grid-tag"}>Demo</div>;
}

export function EnterpriseTag() {
  return <div className={"grid-tag"}>Enterprise</div>;
}

export function SupportTag() {
  return <div className={"grid-tag"}>Support</div>;
}
